import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogTitle } from '@/shared/ui/dialog'

interface MediaPreviewDialogProps {
  /** Image to show; `null` keeps the dialog closed. */
  url: string | null
  onClose: () => void
}

/** Full-size preview of an uploaded tour image. */
export function MediaPreviewDialog({ url, onClose }: MediaPreviewDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={url !== null}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <DialogContent className="max-h-[90vh] max-w-[min(90vw,56rem)] gap-0 overflow-hidden p-2 sm:p-4">
        <DialogTitle className="sr-only">{t('common.preview')}</DialogTitle>
        {url !== null && (
          <img
            src={url}
            alt=""
            className="max-h-[min(85vh,calc(90vh-4rem))] w-full object-contain"
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
